import { CheckCircleOutlined } from "@ant-design/icons";
import { Avatar, Button, Dropdown, Input, Menu, message, Modal, Popconfirm, Spin, Tag } from "antd";
import * as AUTH_SERVICES from "api/services/auth/auth.services";
import { calculateTimeDifference, FLAGS, StatusCode } from "common/enums";
import Matiers from "components/matiers";
import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { setIsReservationsUpdated } from "store/app/appSlice";
import { setChatReceiverId, setSelectUserChat, toggleAppChat } from "store/AppChat/appChat";
import { openProfileDetailsDrawer, setProfileDetailsID, setProfileDetailsType } from "store/auth/authSlice";
import { setIsDrawerInstaProf } from "store/chat/roomSlice";
import { useFindRoomMutation } from "store/services/chat";
import ClockIcon from "../../../assets/images/app/clock_icon.svg";
import CancelIcon from "../../../assets/images/app/i_icon.svg";
import students from "../../../assets/images/app/iam_student.svg";
import MoreOptions from "../../../assets/images/app/options_icon.svg";
import s from "./calendar.module.css";

interface CoursesRoomProps {
    course: object | any;
}

const TeacherCoursesRoom: FC<CoursesRoomProps> = ({ course }) => {

    const dispatch = useDispatch();
    const auth = useSelector((state) => state.auth);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isLoadingData, setIsLoadingData] = useState<boolean>(false);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [popconfirmVisible, setPopconfirmVisible] = useState(false);

    const courseDate = new Date(course?.startDate);

    // Add 1 days to the course date
    const limitDate = new Date(courseDate);
    limitDate.setDate(limitDate.getDate() + 1);

    // Optional: make it end of that day (23:59)
    limitDate.setHours(23, 59, 59, 999);

    // Check if now is after that limit
    const isPast = new Date() > limitDate;

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1050);
    const handleResize = () => {
        setIsMobile(window.innerWidth <= 1050);
    };
    window.addEventListener('resize', handleResize);

    const [openMobileModal, setOpenMobileModal] = useState(false);

    const [findRoom, { isSuccess }] = useFindRoomMutation();

    useEffect(() => {
        if (isSuccess) {
            setIsModalOpen(false);
            setIsLoadingData(false);
            dispatch(setSelectUserChat(true));
            dispatch(toggleAppChat(true));
        }
    }, [isSuccess]);

    const handleDisplayMessagerie = () => {
        dispatch(setIsDrawerInstaProf(false));
        setIsLoadingData(true);
        const finalData = {
            actor1: course?.profId?._id,
            actor2: course?.studId?._id,
            flag: FLAGS.SINGLE_FLAG,
            type: "",
            instaprof: "",
        };
        findRoom(finalData);
        dispatch(setChatReceiverId(course?.studId?._id));
    };

    const handleMenuClick = (e: any) => {
        if (e.key === "0") {
            if (isMobile) {
                e.preventDefault();
                setOpenMobileModal(true);
            } else {
                if (course?.commonLink) {
                    window.open(course.commonLink, "_blank", "noopener,noreferrer");
                }
                else if (course?.profLink) {
                    window.open(course.profLink, "_blank", "noopener,noreferrer");
                }
            }
        }
        else if (e.key === "1") {
            setPopconfirmVisible(true);
            setDropdownVisible(false);
        }
        else if (e.key === "2") {
            setDropdownVisible(false);
            handleDisplayMessagerie();
        }
    };

    const handleConfirm = () => {
        setPopconfirmVisible(false);
        setIsLoadingData(true);
        checkCancelMeeting();
    };

    const handleCancel = () => {
        setPopconfirmVisible(false);
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
    const [cancelMessage, setCancelMessage] = useState("");

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancelModal = () => {
        setIsModalOpen(false);
    };

    const handleScheduleMeeting = () => {
        handleDisplayMessagerie();
    };

    const handleCancelMeetModal = () => {
        setIsCancelModalOpen(false);
    };

    const menu = (
        course?.typeCreneaux !== "collectif" ? <Menu onClick={handleMenuClick}>
            <Menu.Item key="0">Rejoindre le meet</Menu.Item>
            <Menu.Item key="1">Annuler le meet</Menu.Item>
            {course?.codeCoupon?.couponType !== "FREE_CLASS" && <Menu.Item key="2">Replanifier le meet</Menu.Item>}
        </Menu> : <Menu onClick={handleMenuClick}>
            <Menu.Item key="0">Rejoindre le meet</Menu.Item>
        </Menu>
    );

    const cancelMeeting = async () => {
        setIsLoading(true);
        try {
            if (cancelMessage !== "") {
                const response = await AUTH_SERVICES.cancelMeeting(course?._id, cancelMessage, auth?.user?._id);
                if (response?.statusCode === StatusCode.CREATED) {
                    message.success({
                        content: "Meet annulé ",
                    });
                    setTimeout(() => {
                        dispatch(setIsReservationsUpdated(true));
                    }, 2000);
                    setIsLoading(false);
                    setIsModalOpen(false);
                }
                else {
                    message.warning({
                        content: "Ooops, erreur lors de l'annulation",
                    });
                    setIsLoading(false);
                }
            }
            else {
                message.warning({
                    content: "Ooops, entre le message de l'annulation",
                });
                setIsLoading(false);
            }
        } catch (error: any) {
            message.warning({
                content: error?.response?.data?.message,
            });
            setIsLoading(false);
        }
    }

    const handleProfileDetails = () => {
        dispatch(setProfileDetailsID(course?.studId?.uid));
        dispatch(setProfileDetailsType("student"));
        dispatch(openProfileDetailsDrawer());
    }

    const checkCancelMeeting = async () => {
        setIsLoading(true);
        try {
            const response = await AUTH_SERVICES.checkCancelMeeting(auth?.user?._id, course?._id);
            if (response?.statusCode === StatusCode.OK) {
                if (response?.data) {
                    setIsCancelModalOpen(true);
                    setIsLoadingData(false);
                }
                else {
                    setIsCancelModalOpen(false);
                    setIsLoadingData(false);
                    showModal();
                }
            }
            else {
                message.warning({
                    content: response?.data?.message,
                });
            }
        } catch (error: any) {
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                "Erreur interne du serveur. Veuillez réessayer plus tard.";

            message.warning({
                content: errorMessage,
            });
        }
        finally {
            setIsLoading(false);
        }
    }

    return (
        <>
            <div className={`${course?.status === "CANCELED" ? s.classeCardDeleted : course?.codeCoupon ? s.classeCardCoupon : s.classeCard}`}>
                <div className={course?.codeCoupon ? s.cardClassBoxCoupon : s.cardClassBox}>
                    <div className={s.avatarNameBox} onClick={handleProfileDetails}>
                        <Avatar.Group
                            maxCount={3}
                            maxStyle={{
                                color: "#f56a00",
                                backgroundColor: "#fde3cf",
                            }}
                            style={{ marginRight: isMobile ? "0px" : "5px", cursor: "pointer" }}
                        >
                            <Avatar
                                size={45}
                                style={{ backgroundColor: "#FFF2E0", boxShadow: "0px 3px 6px #00000029", position: "relative", left: isMobile ? "20px" : "0px" }}
                                src={course?.typeCreneaux === "collectif" ? students : course?.studId?.profile}
                            />
                            {course?.typeCreneaux !== "individuel" && <Avatar
                                size={45}
                                style={{ backgroundColor: "#FFF2E0", boxShadow: "0px 3px 6px #00000029", position: "relative", left: isMobile ? "-5px" : "-25px" }}
                                src={students}
                            />}
                            {course?.typeCreneaux !== "individuel" && <Avatar
                                size={45}
                                style={{ backgroundColor: "#FFF2E0", boxShadow: "0px 3px 6px #00000029", position: "relative", left: isMobile ? "-30px" : "-50px" }}
                                src={students}
                            />}
                        </Avatar.Group>
                        <div style={{ position: "relative", top: isMobile ? "5px" : "0px", left: isMobile ? "0px" : !isMobile && course?.typeCreneaux !== "individuel" ? "-40px" : "15px", fontSize: isMobile ? "1em" : "13px", textTransform: "capitalize", cursor: "pointer" }}>{course?.typeCreneaux !== "individuel" ? "Cours collectif" : course?.studId?.firstname + " " + course?.studId?.lastname}</div>
                    </div>
                    {isMobile && course?.typeCreneaux !== "collectif" && course?.topic?.title && course?.level?.title && <Matiers
                        cours={course?.topic?.title || "null"}
                        level={course?.level?.title || "null"}
                    />}
                    <div className={s.detailsBox}>
                        <div className={s.timeBox}>
                            {!isMobile && <img src={ClockIcon} height={15} style={{ marginRight: "10px" }}></img>}
                            <div className={s.times}>
                                <span className={s.time}>{isMobile && <img src={ClockIcon} height={10} style={{ marginRight: "5px" }}></img>} De {course?.range[0]} à {course?.range[course?.range?.length - 1]}</span>
                                <span className={s.timeDescription}>Séance de “{calculateTimeDifference(course?.range[0], course?.range[course?.range.length - 1])}”</span>
                            </div>
                        </div>
                        {!isMobile && course?.typeCreneaux !== "collectif" && course?.topic?.title && course?.level?.title && <div style={{ width: "35%" }}>
                            <Matiers
                                cours={course?.topic?.title || "null"}
                                level={course?.level?.title || "null"}
                            />
                        </div>}
                        {course?.typeCreneaux !== "collectif" && <div className={s.amountBox}>
                            {/* <span style={{ width: "auto" }}>Séance réservée pour</span> */}
                            {course?.codeCoupon && (course?.codeCoupon?.couponType === "FREE_CLASS" || course?.codeCoupon?.couponType === "FREE_LINK_DISCOUNT") ? <div className={s.priceBox}>Cours gratuit</div> : <div className={s.priceBox}>{(course?.byCredits === "oui" || course?.byCredits === "true") ? course?.creditedValue + " Crédit" : course?.price + " €"}</div>}
                        </div>}
                        {course?.typeCreneaux === "collectif" && <div className={s.amountBox}>
                            {/* <span style={{ width: "auto" }}>Séance réservée pour</span> */}
                            {course?.pricePerStudent ? <div className={s.priceBox}>{course?.pricePerStudent} {course?.pricePerStudent >= 2 ? "Crédits" : "Crédit"}</div> : <div className={s.priceBox}>{course?.price} {course?.price >= 2 ? "Crédits" : "Crédit"}</div>}
                        </div>}
                    </div>

                    {false ? (
                        <Tag
                            icon={<CheckCircleOutlined />}
                            color="success"
                        >
                            success
                        </Tag>
                    ) : (
                        isLoading || isLoadingData ? <div>
                            <Spin />
                        </div> : <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                            {/* {course?.status !== "CANCELED" && <a href={course?.typeCreneaux === "collectif" ? course?.commonLink : course?.profLink} target="_blank"><Button className={s.meetButton}>
                                {!isMobile && "Rejoindre le meet"} <img src={MeetIcon} height={isMobile ? 14 : 18} style={{ marginLeft: isMobile ? "0px" : "5px" }}></img>
                            </Button></a>} */}
                            {!isMobile && course?.status !== "CANCELED" && course?.typeCreneaux !== "collectif" && <Popconfirm
                                title={`Veux-tu annuler ce meet?`}
                                visible={popconfirmVisible}
                                onVisibleChange={(visible) => {
                                    if (!isLoading) {
                                        setPopconfirmVisible(visible);
                                    }
                                }}
                                onConfirm={handleConfirm}
                                onCancel={handleCancel}
                                okText="Oui"
                                cancelText="Non"
                            >
                                <Button type="primary" />
                            </Popconfirm>}
                            {course?.status !== "CANCELED" && <Dropdown overlay={menu} visible={isPast ? false : dropdownVisible} onVisibleChange={setDropdownVisible} overlayStyle={{ border: "none" }}>
                                <Button disabled={isPast} onClick={() => setDropdownVisible(true)} className={isPast ? s.disabledMeetButton : s.meetButton}>
                                    <img src={MoreOptions} height={isMobile ? 14 : 18} style={{ marginRight: 10 }}></img>
                                    Options
                                </Button>
                            </Dropdown>}
                            {course?.status === "CANCELED" && <div className={s.cancelBox}>
                                <div className={s.horizontalLineDeleted}></div>
                                <span>
                                    <img src={CancelIcon} height={isMobile ? 10 : 18} style={{ marginRight: "5px", marginLeft: isMobile ? "0px" : "20px" }}></img>
                                    Meet annulé
                                </span>
                            </div>}
                        </div>
                    )}
                </div>
            </div>

            {isMobile && course?.status !== "CANCELED" && <Popconfirm
                title={`Veux-tu annuler ce meet?`}
                visible={popconfirmVisible}
                onVisibleChange={(visible) => {
                    if (!isLoading) {
                        setPopconfirmVisible(visible);
                    }
                }}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
                okText="Oui"
                cancelText="Non"
            >
                <Button type="primary" />
            </Popconfirm>}

            <Modal
                visible={openMobileModal}
                onCancel={() => setOpenMobileModal(false)}
                footer={null}
                centered
            >
                <div style={{ textAlign: "center", padding: "10px" }}>
                    <h3 style={{ marginBottom: "10px" }}>
                        ⚠️ Accès non disponible sur mobile
                    </h3>

                    <p style={{ color: "#665" }}>
                        Vous ne pouvez pas participer à ce cours depuis votre téléphone.
                        <br />
                        Merci d'utiliser un ordinateur.
                    </p>

                    <Button
                        type="primary"
                        style={{ marginTop: "15px" }}
                        onClick={() => setOpenMobileModal(false)}
                    >
                        OK
                    </Button>
                </div>
            </Modal>

            {/* Cancel Meet */}
            <Modal
                title={null}
                visible={isCancelModalOpen}
                onCancel={handleCancelMeetModal}
                footer={null}
                centered={true}
                closable={false}
            >
                <div style={{
                    border: '1px solid #000',
                    borderRadius: 8,
                    padding: 16,
                    backgroundColor: '#FFF'
                }}>
                    <p style={{ marginBottom: 24 }}>
                        <strong>Attention :</strong> Ce cours sera annulé à moins de 2 heures.
                        <br />
                        Es-tu sûr(e) de vouloir continuer la démarche d'annulation ?
                    </p>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                        <Button className={s.scheduleButton} loading={isLoadingData} onClick={() => setIsCancelModalOpen(false)}>
                            Non, revenir
                        </Button>
                        <Button className={s.cancelButton} loading={isLoading || isLoadingData} onClick={() => { setIsCancelModalOpen(false); setIsModalOpen(true) }}>
                            Oui, continuer
                        </Button>
                    </div>
                </div>
            </Modal>

            <Modal
                title={
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
                        <Avatar.Group
                            maxCount={3}
                            maxStyle={{
                                color: "#f56a00",
                                backgroundColor: "#fde3cf",
                            }}
                            style={{ marginRight: "5px" }}
                        >
                            <Avatar
                                size={45}
                                style={{ backgroundColor: "#FFF2E0", boxShadow: "0px 3px 6px #00000029" }}
                                src={auth?.user?.profile}
                            />
                        </Avatar.Group>
                        Annulation de meet
                    </div>
                }
                visible={isModalOpen}
                onCancel={handleCancelModal}
                footer={null}
            >
                <div style={{ marginBottom: "16px", textTransform: "capitalize" }}>
                    <strong>
                        {new Intl.DateTimeFormat("fr-FR", {
                            weekday: "long",
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                        }).format(new Date(course?.day))}
                    </strong>
                </div>
                <div style={{ marginBottom: "8px" }}>
                    <span>Message pour {course?.studId?.firstname}</span>
                </div>
                <Input.TextArea
                    rows={3}
                    placeholder="J'annule le meet parce que..."
                    value={cancelMessage}
                    onChange={(e) => setCancelMessage(e.target.value)}
                    style={{ borderRadius: "10px" }}
                    required={true}
                />
                <div
                    style={{
                        marginTop: "24px",
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        justifyContent: isMobile ? "center" : "space-between",
                    }}
                >
                    {course?.codeCoupon?.couponType !== "FREE_CLASS" && <Button className={s.scheduleButton} loading={isLoadingData} onClick={handleScheduleMeeting}>
                        Reprogrammer plutôt
                    </Button>}
                    <Button className={s.cancelButton} loading={isLoading || isLoadingData} onClick={cancelMeeting}>
                        Confirmer l'annulation
                    </Button>
                </div>
            </Modal>
        </>
    );
};

export default TeacherCoursesRoom;